/**
 * @file index.tsx
 * @author liuchen(loocliu@tencent.com)
 */
import React, { useCallback, useState } from 'react';
import { MessagePlugin, Textarea, TextareaValue } from 'tdesign-react';

import styles from './style/index.module.less';

interface IChatInputProps {
  onSubmit: (value: string, botIds: string[]) => void;
  style?: React.CSSProperties;
  disabled?: boolean;
}

const ChatInput = ((props: IChatInputProps) => {
  const {
    onSubmit,
    style,
    disabled = false,
  } = props;

  const [value, setValue] = useState<string>('');
  const [inputMode] = useState<'keyboard' | 'voice'>('keyboard');
  const [lock, setLock] = useState(false);

  const handleInput = useCallback(
    (value: string) => {
      setValue(value);
    },
    [],
  );

  const handleStart = useCallback(() => {
    setLock(true);
  }, []);

  const handleEnd = useCallback(() => {
    setLock(false);
  }, []);

  const handleTap1 = useCallback(() => {
    MessagePlugin.info('PC端暂不提供语音服务');
  }, []);

  const handleKeydown = useCallback((_: TextareaValue, ctx: {
    e: React.KeyboardEvent<HTMLTextAreaElement>;
  }) => {
    if (ctx.e.code === 'Enter') {
      ctx.e.preventDefault();
    }
  }, []);

  const handleEnter = useCallback((_: TextareaValue, ctx: {
    e: React.KeyboardEvent<HTMLTextAreaElement>;
  }) => {
    if (ctx.e.code === 'Enter') {
      if (lock) {
        return;
      }
      if (value.trim().length === 0) {
        return;
      }
      onSubmit(value.trim(), []);
      setValue('');
    }
  }, [value, onSubmit, lock]);

  return (
    <>
      <div className={styles['input-wrapper']} style={style}>
        <div className={styles.switch} onClick={handleTap1}>
          {inputMode === 'keyboard' ? (
            <img
              className={styles.icon1}
              src="https://media-img.puui.qpic.cn/media_img/0/lena/PICrihxfv_29_43/0"
            ></img>
          ) : (
            <img
              className={styles.icon2}
              src="https://media-img.puui.qpic.cn/media_img/0/lena/PICnxhbfv_45_44/0"
            ></img>
          )}
        </div>
        <Textarea
          value={value}
          className={styles.input}
          disabled={disabled}
          placeholder="请输入对话"
          onChange={handleInput}
          onCompositionStartCapture={handleStart}
          onCompositionEndCapture={handleEnd}
          onKeyup={handleEnter}
          onKeydown={handleKeydown}
          autosize={{ maxRows: 1 }}
          wrap={'off'}
        ></Textarea>
      </div>
    </>
  );
});

export default (ChatInput);
